import { defineMessages } from 'react-intl-next';

export const dropPlaceholderMessages: {
	dropPlaceholderLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dropPlaceholderLabel: {
		id: 'fabric.editor.dropPlaceholderLabel',
		defaultMessage: 'Document',
		description: 'document label for an media icon',
	},
});
